import * as React from "react";

// This component does nothing other than ensure that the shell including the SlaMeasurementContainer is loaded
// Once we are migrated from Angular to React, this component can be removed.
export const SlaMeasurementMounter: React.FC = () => {
  return null;
};
